import { useUserAccount } from '@/api/user/queries';
import { ModalsKey } from '@/enums/modalsKey';
import { useModal } from '@/hooks/modals/useModal';
import useTranslation from 'next-translate/useTranslation';
import { ModalWithVersion } from '../core/Modal/WithVersion';
import LuckySpinContent from './Content';
import styles from './styles.module.scss';

export default function LuckySpinModal() {
  const { t } = useTranslation('common');

  const { isOpen } = useModal(ModalsKey.LuckySpin);
  const { isAuthorized } = useUserAccount();

  return (
    <ModalWithVersion
      condition={!!isAuthorized && isOpen}
      modal={ModalsKey.LuckySpin}
      title={t('lucky_spin_title')}
      className={styles.container}
    >
      <LuckySpinContent />
    </ModalWithVersion>
  );
}
